<div class="absolute -left-4 -right-4 top-0 h-full max-h-80 w-auto overflow-hidden md:hidden" aria-hidden="true">
    <img
        class="animation layer1 absolute -bottom-1 max-w-none"
        [src]="(assetsPath$ | async) + '/img/ticket-details/animation_layer_3.svg'"
        alt="" />
    <img
        class="animation layer1 layer1-child absolute -bottom-1 max-w-none"
        [src]="(assetsPath$ | async) + '/img/ticket-details/animation_layer_3.svg'"
        alt="" />
    <img
        class="animation layer2 absolute -bottom-1 max-w-none"
        [src]="(assetsPath$ | async) + '/img/ticket-details/animation_layer_2.svg'"
        alt="" />
    <img
        class="animation layer2 layer2-child absolute -bottom-1 max-w-none"
        [src]="(assetsPath$ | async) + '/img/ticket-details/animation_layer_2.svg'"
        alt="" />
    <img
        class="animation layer3 absolute -bottom-1 max-w-none"
        [src]="(assetsPath$ | async) + '/img/ticket-details/animation_layer_1.svg'"
        alt="" />
    <img
        class="animation layer3 layer3-child absolute -bottom-1 max-w-none"
        [src]="(assetsPath$ | async) + '/img/ticket-details/animation_layer_1.svg'"
        alt="" />
</div>
